module.exports = __webpack_public_path__ + "img/overseas_3.81b01dbf.jpg";